import CardHeader from './CardHeader';
import React from 'react';
import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import FieldTypesEnum from '../../../../Enums/FieldTypesEnum';
import BaseCard from './BaseCard';
import NoteCard from './NoteCard';
import DataTable from '../../../../Elements/DataTable/DataTableFigma';
import DataTableActionMenu from '../../../../Elements/DataTable/DataTableActionMenu';
import stringHelper from '../../../../Helpers/stringHelper';

class FieldworkCycleCard extends BaseCard
{
  render ()
  {
    // prettier-ignore
    const ButtonValue =
      this.props.Tier !== undefined &&
        (this.props.Tier.PricingDetails.PricingDetailId === '' || this.props.Tier.PricingDetails.Status === 'Final')
        ? undefined
        : this.props.AddTier;

    return (
      <div className='card'>
        <CardHeader
          sectionNumber={'1'}
          HeaderText={'FIELDWORK CYCLE'}
          changeBodyStatus={this.changeBodyStatus}
          Button={ButtonValue}
          ButtonText='Add Tier'
          bodyactive={this.state.bodyactive}
        />
        {this.state.bodyactive ? (
          <div>
            <NoteCard
              noteActive={this.state.noteActive}
              renderInputField={this.renderInputField}
              name='FieldWorkNotes'
              value={this.props.Tier.PricingDetails}
            />
            <DataTable
              type={{
                FieldsToShowInDataTable: this.FieldsToShowInHeaderDataTable,
                MoneyFields: this.MoneyFields,
                Currency: this.Currency,
              }}
              itemList={this.props.Tier.TierList}
              thereIsNoSuchRowMessageCheck={false}
              smallDataTable={true}
              DataTableType='Header'
            />
            {/* --- */}
            <DataTable
              type={{
                FieldsToShowInDataTable: this.FieldsToShowInDataTable,
                NameOfTheIdField: () => 'TierId',
                FieldsToShowInListTable: [],
                MoneyFields: this.MoneyFields,
                Currency: this.Currency,
              }}
              itemList={this.props.Tier.TierList}
              renderInputFieldFunction={this.renderInputField}
              thereIsNoSuchRowMessageCheck={false}
              smallDataTable={true}
            />
            {/* ---- */}
          </div>
        ) : null}
        <footer className='fieldwork_cycle-card-footer'>
          <DataTable
            type={{
              FieldsToShowInDataTable: this.FieldsToShowInFooterDataTable,
              MoneyFields: this.MoneyFields,
              Currency: this.Currency,
            }}
            headeritemList={this.props.Tier}
            thereIsNoSuchRowMessageCheck={false}
            smallDataTable={true}
          />
        </footer>
      </div>
    );
  }

  FieldsToShowInDataTable ()
  {
    // prettier-ignore
    return [
      { label: 'Tier Name', data: 'Name', type: InputTypesEnum.Text2, tableminWidth: '500px' },
      { label: ' ', data: '', type: FieldTypesEnum.EmptySpace, tableminWidth: '125px' },
      {
        label: '# eval. per cycle',
        data: 'NumEvalsPerCycle',
        type: InputTypesEnum.Number2,
        tableminWidth: '125px',
        fieldType: 'Decimal',
        headerPosition: 'header-text-right',
      },
      {
        label: '# eval. annually',
        data: 'NumEvalsPerYear',
        type: InputTypesEnum.TextReadOnly,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
      {
        label: '% each tier',
        data: 'EachTierPrecentage',
        type: InputTypesEnum.TextReadOnly,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
      { label: ' ', data: FieldworkCycleCard.getActionsContent, type: FieldTypesEnum.ActionButton },
    ];
  }

  FieldsToShowInFooterDataTable ()
  {
    // prettier-ignore
    return [
      { label: '', data: '', tableminWidth: '500px' },
      { label: "TOTAL EVALUATIONS", data: "", type: InputTypesEnum.Text2, tableminWidth: "125px", headerPosition: "header-text-right", },
      { label: "", data: (item) => `Per cycle: ${item.NumEvalsPerCycle}`, tableminWidth: "125px", headerPosition: "header-text-right", },
      { label: "", data: (item) => `Total: ${item.NumEvalsAnnually}`, tableminWidth: "125px", headerPosition: "header-text-right", },
      { label: "", data: '', tableminWidth: "125px", headerPosition: "header-text-right" },
    ];
  }

  FieldsToShowInHeaderDataTable = () =>
  {
    const { PricingDetails } = this.props.Tier;
    // prettier-ignore
    return [
      { label: () => { return `Fieldwork Cycle: ${PricingDetails.FieldworkCycle}, ${stringHelper.plural(PricingDetails.NumCyclesPerYr, "cycle")} per year. (${PricingDetails.NumCyclesPerYr}/yr)`; }, tableminWidth: "500px", },
      { label: " ", data: "NumCyclesPerYr", type: InputTypesEnum.Number2 },
    ];
  };

  static getActionsContent (item)
  {
    return (
      <div>
        <DataTableActionMenu
          options={[
            {
              onClick: () => FieldworkCycleCard.RemoveTier(item.TierId),
              text: 'Remove',
              iconName: 'fa-regular fa-trash-can',
              disabled: item.PricingDetailId === '' || item.Status === 'Final',
            },
          ]}
        />
      </div>
    );
  }

  static RemoveTier (id)
  {
    //
  }
}

export default FieldworkCycleCard;
